import { Button, Grid, Stack } from '@mui/material';
import IconButton from '@mui/material/IconButton';
import { useState } from 'react';
// import EditIcon from "@mui/icons-material/Edit";
// import {
//   useFeedbackModule,
//   useFeedbackQuestion
// } from "@tms/services/tms-feedback";
import { BiEdit, BiLoader } from 'react-icons/bi';
import { useFeedbackModule, useFeedbackQuestion } from 'redux/reducers/user/dashboard/tms-feedback';
import FeedbackModuleModal from './FeedModuleModal';
// import CircularLoader from "@tms/components/Loader/CircularProgress";

const FeedbackModule = () => {
  const [activeRoutineFeedback, setActiveRoutineFeedback] = useState<any>(null);

  const [courseId, setCourseId] = useState<string>();

  const [feedbackQuestionRoutineId, setFeedbackQuestionRoutineId] = useState<number | null>(null);

  const [open, setOpen] = useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };
  const { data: feedbackModule, isLoading } = useFeedbackModule();

  const [items, setItems] = useState({});

  const [openFeedbackModal, setOpenFeedbackModal] = useState(false);

  const handleOpenFeedbackModal = (item: any) => {
    setItems(item);
    setOpenFeedbackModal(true);
  };

  const handleCloseFeedbackModal = () => {
    setOpenFeedbackModal(false);
  };

  const { data: feedbackQuestion } = useFeedbackQuestion(
    feedbackQuestionRoutineId?.toString() ?? '',
    'module'
  );

  return (
    <>
      <FeedbackModuleModal
        openFeedbackModal={openFeedbackModal}
        handleCloseFeedbackModal={handleCloseFeedbackModal}
        dailySessionId={courseId?.toString() || ''}
        feedbackQuestionRoutineId={feedbackQuestionRoutineId}
        items={items}
      />
      <div>
        {feedbackModule ? (
          feedbackModule.map((item, index) => {
            return (
              <>
                <Stack
                  direction={'row'}
                  justifyContent={'space-between'}
                  alignItems={'center'}
                  sx={{
                    backgroundColor: `${index % 2 === 0 ? '#edeff0' : 'white'}`,
                    p: 1.5
                  }}>
                  <Grid item xs={6}>
                    {item?.course?.title}
                  </Grid>
                  <Grid item xs={6} sx={{ display: 'flex', justifyContent: 'end' }}>
                    {item?.feedback_submit_status == false ? (
                      <IconButton color="primary" aria-label="add to shopping cart">
                        <BiEdit
                          onClick={() => {
                            setFeedbackQuestionRoutineId(item?.routine_session);

                            handleOpenFeedbackModal(item);

                            setCourseId(item?.course?.course_id);
                          }}
                        />
                      </IconButton>
                    ) : (
                      <Button
                        style={{
                          background: '#006ECB',
                          color: '#fff',
                          fontSize: '12px',
                          height: '22px'
                        }}>
                        Already Submitted
                      </Button>
                    )}
                  </Grid>
                </Stack>
              </>
            );
          })
        ) : isLoading ? (
          <BiLoader />
        ) : (
          <Stack
            sx={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center'
            }}>
            <h4>No Modules</h4>
          </Stack>
        )}
      </div>
    </>
  );
};

export default FeedbackModule;
